import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { EmployeeCategoriesService } from '../services/employee-categories.service';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { SearchEmployeeCategoriesChanges } from '../models/search-employee-categories-changes.model';
import { EmployeeCategoryChangesModel } from '../models/employee-categories-changes.model';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-employee-categories-changes',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatPaginatorModule, MatTableModule],
  templateUrl: './employee-categories-changes.component.html',
  styleUrl: './employee-categories-changes.component.scss'
})
export class EmployeeCategoriesChangesComponent {
  searchForm: FormGroup;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  searchRequestParams: SearchParameters<SearchEmployeeCategoriesChanges>;
  isLoading: boolean = false;
  pagedData: PagedResult<EmployeeCategoryChangesModel[]>;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  dataSource: MatTableDataSource<EmployeeCategoryChangesModel>;
  searchDone: boolean = false;
  displayedColumns: string[] = ['number', 'time', 'action', 'categoryDescrition', 'fromPsg', 'toPsg', 'actionBy'];

  constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private employeeCategoriesService: EmployeeCategoriesService, ) 
    {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      categoryDescription: new FormControl(''),
      fromDate: new FormControl(''),
      toDate: new FormControl('')
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;        
      }      
    });
  }

  submitForm(): void {   
    this.searchRequestParams = {
      query: {
        categoryDescription: this.searchForm.get('categoryDescription').value || '',
        fromDate: this.searchForm.get('fromDate').value || null,
        toDate: this.searchForm.get('toDate').value || null
      },
      pageIndex: 0,
      pageSize: 10,
      userEmail: this.user.userEmail      
    };
    
    this.search();
  }

  search() {
    if(this.isAdmin){
      this.isLoading = true;
      this.employeeCategoriesService.seachEmployeeCategoriesChanges(this.searchRequestParams)
        .subscribe(data => {
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;      
          this.dataSource = new MatTableDataSource<EmployeeCategoryChangesModel>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<EmployeeCategoryChangesModel>([]);
    }
  }
  
  public pageChangeEvent(event?: PageEvent){
    this.searchRequestParams.pageIndex = event.pageIndex;
    this.searchRequestParams.pageSize = event.pageSize;
    this.search();
  }
}
